<div class="container section__phoneRegister h-full">
  <div class="wrapper">
    <div class="sectionContainer fadeinright animation-duration-200">
      <article>
        <app-sales-breadcrumbs [routes]="routesBreadcrumb"></app-sales-breadcrumbs>

        <div class="mainInfo">
          <h1>De acuerdo, ahora vamos a enrolar el teléfono</h1>
        </div>

        <div class="generalImg generalImg--enrollment mt-20 mb-20">
          <app-enrollment-illustration></app-enrollment-illustration>
        </div>

        <div class="generalDescription mb-30">
          <p class="big">El teléfono quedará como <strong class="highlight">garantía de pago</strong> por el prestamo que te estamos realizando. Es por eso que vamos a enrolarlo.</p>
        </div>

        <div class="subtitle mb-15">
          <h2>Importante:</h2>
        </div>

        <div class="infoBox">
          <ul>
            <li>
              <p>Necesitarás buscar en el teléfono tu <strong>IMEI 1</strong> e ingresarlo.</p>
            </li>
            <li class="border">
              <p>Si tienes algún inconveniente, pueden dirigirte al <strong>chat del bot</strong>, donde te ayudarán a continuar con el proceso.</p>
            </li>
          </ul>
        </div>
      </article>

      <footer>
        <div class="footer__content">
          <button pButton pRipple label="Ya tengo mi IMEI" class="p-button-primary p-button-raised p-button-rounded w-full" (click)="onIntroduceIMEI()"></button>

          <div class="footer__float">
            <p-button label="¿Dónde encontrar mi IMEI?" [text]="true" [plain]="true" (onClick)="onSearchIMEI()"></p-button>
          </div>
        </div>
      </footer>
    </div>
  </div>
</div>

<p-dialog [(visible)]="visibleModalInstructions" (onHide)="onHide()" [modal]="true" [draggable]="false" [resizable]="false" position="bottom">
  <div class="dialog">
    <div class="container">
      <div class="wrapper">
        <div class="dialog__info">
          <h2>¿Dónde encontrar mi IMEI?</h2>
        </div>
        <div class="dialog__text smallPad">
          <h3>Método general</h3>
          <ol>
            <li>Abre la aplicación de llamadas en tu teléfono.</li>
            <li>Marca el código: *#06#.</li>
            <li>El IMEI aparecerá automáticamente en la pantalla.</li>
          </ol>

          <h3>Método alternativo en Android</h3>
          <ol>
            <li>Ve a Ajustes o Configuración.</li>
            <li>Selecciona Acerca del teléfono o Información del dispositivo.</li>
            <li>Busca el apartado llamado Estado o IMEI.</li>
          </ol>

          <h3>Método alternativo en iOS (iPhone)</h3>
          <ol>
            <li>Ve a Configuración.</li>
            <li>Selecciona General y luego Información.</li>
            <li>Busca el IMEI en la lista de detalles.</li>
          </ol>
        </div>
        <div class="dialog__btn">
          <button pButton pRipple label="Ok, ya tengo mi IMEI" class="p-button-primary p-button-raised p-button-rounded w-full" (click)="onIntroduceIMEI()"></button>
        </div>
      </div>
    </div>
  </div>
</p-dialog>

<p-dialog [(visible)]="visibleModalIMEI" (onHide)="onHide()" [modal]="true" [draggable]="false" [resizable]="false" position="bottom">
  <div class="dialog">
    <form [formGroup]="form" (ngSubmit)="onProgressEnrollment()">
      <div class="container">
        <div class="wrapper">
          <div class="dialog__info">
            <h2>Configuración del teléfono</h2>
            <p>Introduce el IMEI de tu teléfono.</p>
          </div>
          <div class="dialog__form smallPadTop">
            <div class="form__group form__group--codeNumber fWidth nMarginBot" [ngClass]="{'form__error':(submitted || f['imei'].touched || !f['imei'].pristine) && f['imei'].errors}">
              <input pInputText type="text" formControlName="imei">
              <span class="form__msgError" *ngIf="(submitted || f['imei'].touched || !f['imei'].pristine) && f['imei'].errors">
                <small class="p-error" *ngIf="f['imei'].errors?.['required']">{{ "IMEI" | required }}</small>
                <small class="p-error" *ngIf="f['imei'].hasError('serverError')">{{ errorMessage }}</small>
              </span>
            </div>
          </div>
          <div class="dialog__btn">
            <button pButton pRipple type="submit" label="Activar" class="p-button-primary p-button-raised p-button-rounded w-full" [loading]="loading" [disabled]="this.form.invalid"></button>
            <p-button *ngIf="hasEnrollmentError" label="Volver al listado de productos" icon="pi pi-angle-left" iconPos="left" [text]="true" [plain]="true"
                      (click)="onGotoStep(SalesWorkflowSteps['select-product'])"></p-button>
          </div>
        </div>
      </div>
    </form>
  </div>
</p-dialog>

<app-sales-phone-register-engine-error-message></app-sales-phone-register-engine-error-message>